import { Injectable } from "@angular/core";
import { StatsNormalizerService } from "../stats-normalizer/stats-normalizer.service";

interface ICountLists {
  requests: number[];
  notices: number[];
  time: string[];
}

@Injectable()
export class ErrorRateListService {
  constructor(private statsNormalizerService: StatsNormalizerService) {}

  public statsFor(countLists: ICountLists, dur: any, lastN: any) {
    const normalizedTotal =
      this.statsNormalizerService.populateEmptyDaysWithZeros(
        countLists.requests,
        countLists.time,
        dur,
        lastN,
      );

    return this.statsNormalizerService
      .populateEmptyDaysWithZeros(
        countLists.notices,
        countLists.time,
        dur,
        lastN,
      )
      .map((error: number, i: number) => {
        if (error === 0) {
          return 0;
        } else {
          return 100 * (error / normalizedTotal[i]);
        }
      });
  }
}
